<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[120] p-4">
    <div class="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
      <!-- Header -->
      <div class="bg-gradient-to-r from-indigo-600 to-purple-600 text-white p-6 rounded-t-xl">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <div>
              <h2 class="text-xl font-bold">Añadir Avalista</h2>
              <p class="text-white/80 text-sm">Información del avalista</p>
            </div>
          </div>
          <button 
            @click="$emit('close')"
            class="w-8 h-8 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Contenido -->
      <div class="p-6 space-y-6">
        

        <!-- Formulario -->
        <form @submit.prevent="saveGuarantor" class="space-y-6">
          <!-- Datos básicos del avalista -->
          <div class="bg-white border border-gray-200 rounded-xl p-6">
            <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <div class="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              Información del avalista
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <!-- Nombre completo -->
              <FormField
                v-model="guarantorData.fullName"
                id="fullName"
                label="Nombre completo"
                placeholder="Nombre y apellidos del avalista"
                :with-border="true"
                required
              />

              <!-- DNI -->
              <FormField
                v-model="guarantorData.dni"
                id="dni"
                label="DNI/NIE"
                placeholder="12345678A"
                :with-border="true"
                required
              />
              
              <!-- Mostrar error de DNI si existe -->
              <div v-if="dniError" class="md:col-span-2">
                <p class="text-sm text-red-600">{{ dniError }}</p>
              </div>

              <!-- Teléfono -->
              <FormField
                v-model="guarantorData.phone"
                id="phone"
                type="tel"
                label="Teléfono"
                placeholder="+34 600 000 000"
                :with-border="true"
                required
              />

              <!-- Email -->
              <FormField
                v-model="guarantorData.email"
                id="email"
                type="email"
                label="Email"
                placeholder="avalista@email.com"
                :with-border="true"
                required
              />

              <!-- Relación -->
              <div class="md:col-span-2">
                <FormField
                  v-model="guarantorData.relationshipType"
                  id="relationshipType"
                  label="Relación contigo"
                  placeholder="Selecciona una relación"
                  :with-border="true"
                  select
                  :options="relationshipOptions"
                  required
                />
              </div>
            </div>
          </div>

          <!-- Subida de fotos del DNI -->
          <div class="bg-white border border-gray-200 rounded-xl p-6">
            <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <div class="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              Fotos del DNI del avalista
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-1 gap-6">
              <!-- DNI Frontal -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Foto del DNI (frontal)
                </label>
                <div class="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-indigo-400 transition-colors">
                  <input
                    ref="dniFrontInput"
                    type="file"
                    accept="image/*"
                    class="hidden"
                    @change="handleDniFrontUpload"
                  />
                  <div v-if="!dniFrontPreview" @click="$refs.dniFrontInput.click()" class="cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mx-auto text-gray-400 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                    <p class="text-sm text-gray-600">Subir foto frontal del DNI</p>
                  </div>
                  <div v-else class="relative">
                    <img :src="dniFrontPreview" class="max-h-32 mx-auto rounded-lg" alt="DNI Frontal" />
                    <button
                      type="button"
                      @click="removeDniFront"
                      class="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center text-xs hover:bg-red-600"
                    >
                      ×
                    </button>
                  </div>
                </div>
                
                <!-- Estado de verificación OCR para frontal -->
                <div v-if="dniFrontPreview" class="mt-3">
                  <div class="flex items-center space-x-2">
                    <!-- Verificando -->
                    <div v-if="ocrVerificationStatus.front.status === 'verifying'" class="flex items-center text-blue-600">
                      <svg class="animate-spin -ml-1 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      <span class="text-sm">Verificando documento...</span>
                    </div>
                    
                    <!-- Verificado -->
                    <div v-else-if="ocrVerificationStatus.front.status === 'verified'" class="flex items-center text-green-600">
                      <svg class="mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span class="text-sm">DNI verificado correctamente</span>
                      <span v-if="ocrVerificationStatus.front.confidence" class="ml-2 text-xs bg-green-100 text-green-800 px-2 py-1 rounded">
                        {{ Math.round(ocrVerificationStatus.front.confidence * 100) }}% confianza
                      </span>
                    </div>
                    
                    <!-- Error -->
                    <div v-else-if="ocrVerificationStatus.front.status === 'failed'" class="flex items-center text-red-600">
                      <svg class="mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span class="text-sm">{{ ocrVerificationStatus.front.message }}</span>
                      <button @click="retryOcrVerification('front')" 
                              class="ml-2 text-xs bg-red-100 text-red-800 px-2 py-1 rounded hover:bg-red-200 transition-colors">
                        Reintentar
                      </button>
                    </div>
                    
                    <!-- Pendiente -->
                    <div v-else-if="ocrVerificationStatus.front.status === 'pending' && guarantorData.dni" class="flex items-center text-gray-500">
                      <svg class="mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span class="text-sm">Pendiente de verificación</span>
                      <button @click="retryOcrVerification('front')" 
                              class="ml-2 text-xs bg-gray-100 text-gray-800 px-2 py-1 rounded hover:bg-gray-200 transition-colors">
                        Verificar ahora
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-4 space-y-3">
              <div class="text-xs text-gray-500 bg-gray-50 p-3 rounded-lg flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-indigo-500 mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Estas fotos son necesarias para verificar la identidad del avalista. Se enviarán por email seguro para su verificación y firma digital.</span>
              </div>
              
              <div class="text-xs text-blue-600 bg-blue-50 p-3 rounded-lg flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-blue-500 mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span><strong>Verificación automática:</strong> El sistema verificará automáticamente que el DNI de las imágenes coincide con el número introducido para garantizar la autenticidad.</span>
              </div>
            </div>
          </div>

          <!-- Información sobre el proceso -->
          <div class="bg-blue-50 border border-blue-200 rounded-xl p-4">
            <div class="flex items-start space-x-3">
              <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h4 class="text-sm font-semibold text-blue-800 mb-1">¿Cómo funciona el proceso?</h4>
                <ul class="text-sm text-blue-700 space-y-1">
                  <li>• Se enviará un email seguro al avalista con un enlace único</li>
                  <li>• El avalista podrá revisar toda la información desde su dispositivo</li>
                  <li>• Deberá firmar digitalmente para confirmar su compromiso como avalista</li>
                  <li>• Una vez firmado, recibirás una notificación de confirmación</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Botones de acción -->
          <div class="flex flex-col sm:flex-row gap-3 pt-4">
            <button
              type="button"
              @click="$emit('close')"
              class="flex-1 px-6 py-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              :disabled="!isFormValid || isLoading"
              class="flex-1 px-6 py-3 text-sm font-medium text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 disabled:from-gray-400 disabled:to-gray-400 rounded-lg shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200 flex items-center justify-center"
            >
              <svg v-if="isLoading" class="animate-spin -ml-1 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {{ isLoading ? 'Enviando...' : 'Enviar Invitación al Avalista' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { getAuth } from 'firebase/auth'
import { doc, updateDoc } from 'firebase/firestore'
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'
import { getFunctions, httpsCallable } from 'firebase/functions'
import { db } from '../firebase'
import FormField from './FormField.vue'

// Props
const props = defineProps({
  existingGuarantor: {
    type: Object,
    default: () => ({})
  }
})

// Emits
const emit = defineEmits(['close', 'guarantor-saved'])

// Estado reactivo
const isLoading = ref(false)
const dniError = ref('')
const dniFrontFile = ref(null)
const dniFrontPreview = ref('')

// Estados de verificación OCR
const ocrVerificationStatus = ref({
  front: { status: 'pending', message: '', confidence: 0 } // pending, verifying, verified, failed
})
const isVerifyingOcr = ref(false)

// Opciones para el select de relación
const relationshipOptions = [
  'Padre/Madre',
  'Hermano/a',
  'Cónyuge',
  'Amigo/a',
  'Otro'
]

// Datos del avalista
const guarantorData = ref({
  fullName: '',
  dni: '',
  phone: '',
  email: '',
  relationshipType: '',
  dniFrontUrl: '',
  
})

// Computed
const isFormValid = computed(() => {
  // Verificar que el DNI no esté vacío antes de validar
  const dniValue = guarantorData.value.dni
  const dniValidation = dniValue ? validateDni(dniValue) : { isValid: false }
  
  // Requiere solo la imagen frontal verificada
  const frontVerified = ocrVerificationStatus.value.front.status === 'verified'
  
  return guarantorData.value.fullName &&
    dniValidation.isValid &&
    guarantorData.value.phone &&
    guarantorData.value.email &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(guarantorData.value.email) &&
    guarantorData.value.relationshipType &&
    frontVerified
})

// Métodos
const validateDni = (dni) => {
  if (!dni || typeof dni !== 'string') {
    return { isValid: false, error: 'El DNI/NIE es obligatorio' }
  }

  // Limpiar y formatear DNI
  const cleanDni = dni.toUpperCase().replace(/[^0-9A-Z]/g, '')

  // Verificar formato DNI (8 números + 1 letra)
  if (/^[0-9]{8}[A-Z]$/.test(cleanDni)) {
    const numbers = cleanDni.substring(0, 8)
    const letter = cleanDni.substring(8, 9)
    const expectedLetter = 'TRWAGMYFPDXBNJZSQVHLCKE'[parseInt(numbers) % 23]
    
    if (letter !== expectedLetter) {
      return { isValid: false, error: 'La letra del DNI no es correcta' }
    }
    return { isValid: true, dni: cleanDni }
  }

  // Verificar formato NIE (1 letra + 7 números + 1 letra)
  if (/^[XYZ][0-9]{7}[A-Z]$/.test(cleanDni)) {
    const firstLetter = cleanDni.substring(0, 1)
    const numbers = cleanDni.substring(1, 8)
    const lastLetter = cleanDni.substring(8, 9)
    
    // Convertir primera letra a número para cálculo
    const letterToNumber = { 'X': '0', 'Y': '1', 'Z': '2' }
    const numberForCalculation = letterToNumber[firstLetter] + numbers
    const expectedLetter = 'TRWAGMYFPDXBNJZSQVHLCKE'[parseInt(numberForCalculation) % 23]
    
    if (lastLetter !== expectedLetter) {
      return { isValid: false, error: 'La letra del NIE no es correcta' }
    }
    return { isValid: true, dni: cleanDni }
  }

  return { isValid: false, error: 'Formato de DNI/NIE inválido' }
}

// Función para verificar DNI con OCR
const verifyDniWithOcr = async (imageFile, documentType) => {
  if (!guarantorData.value.dni || !validateDni(guarantorData.value.dni).isValid) {
    showToast('Por favor, introduce un DNI válido antes de subir las imágenes')
    return false
  }

  const auth = getAuth()
  const user = auth.currentUser
  if (!user) {
    showToast('Error de autenticación')
    return false
  }

  try {
    isVerifyingOcr.value = true
    ocrVerificationStatus.value[documentType].status = 'verifying'
    ocrVerificationStatus.value[documentType].message = 'Verificando documento...'

    // Convertir imagen a base64
    const base64Image = await new Promise((resolve) => {
      const reader = new FileReader()
      reader.onload = (e) => resolve(e.target.result)
      reader.readAsDataURL(imageFile)
    })

    // Llamar a la Cloud Function
    const functions = getFunctions()
    const verifyDniDocument = httpsCallable(functions, 'verifyDniDocument')
    const result = await verifyDniDocument({
      imageBase64: base64Image,
      manualDni: guarantorData.value.dni,
      documentType: documentType,
      userId: user.uid
    })

    const { success, confidence, matches, message } = result.data

    if (success && matches) {
      ocrVerificationStatus.value[documentType].status = 'verified'
      ocrVerificationStatus.value[documentType].message = 'DNI verificado correctamente'
      ocrVerificationStatus.value[documentType].confidence = confidence
      showToast(`✅ ${documentType === 'front' ? 'Frontal' : 'Dorso'} del DNI verificado correctamente`)
      return true
    } else {
      ocrVerificationStatus.value[documentType].status = 'failed'
      ocrVerificationStatus.value[documentType].message = message || 'Error en la verificación'
      ocrVerificationStatus.value[documentType].confidence = confidence || 0
      showToast(`❌ Error: ${message}`)
      return false
    }
  } catch (error) {
    console.error('Error en verificación OCR:', error)
    ocrVerificationStatus.value[documentType].status = 'failed'
    ocrVerificationStatus.value[documentType].message = 'Error interno de verificación'
    showToast('Error al verificar el documento. Inténtalo de nuevo.')
    return false
  } finally {
    isVerifyingOcr.value = false
  }
}

// Función para re-verificar manualmente
const retryOcrVerification = async (documentType) => {
  const file = documentType === 'front' ? dniFrontFile.value : null
  if (file) {
    await verifyDniWithOcr(file, documentType)
  }
}

// Función para mostrar mensajes toast
const showToast = (message) => {
  alert(message) // Por ahora usar alert, pero se puede mejorar con un componente toast
}

// Watcher para validar DNI cuando cambie
watch(() => guarantorData.value.dni, async (newDni) => {
  if (newDni) {
    const validation = validateDni(newDni)
    if (!validation.isValid) {
      dniError.value = validation.error
    } else {
      dniError.value = ''
      // Actualizar con el DNI limpio si es válido
      if (validation.dni !== newDni) {
        guarantorData.value.dni = validation.dni
      }
      
      // Si el DNI es válido y hay imágenes subidas, re-verificar
      if (dniFrontFile.value) {
        await verifyDniWithOcr(dniFrontFile.value, 'front')
      }
    // Eliminado: verificación de dorso
    }
  } else {
    dniError.value = ''
  }
}, { immediate: false })

const handleDniFrontUpload = async (event) => {
  const file = event.target.files[0]
  if (!file) return
  
  if (!file.type.startsWith('image/')) {
    showToast('Por favor, selecciona un archivo de imagen válido')
    return
  }
  
  if (file.size > 5 * 1024 * 1024) {
    showToast('El archivo es demasiado grande. Máximo 5MB')
    return
  }
  
  dniFrontFile.value = file
  
  // Mostrar vista previa
  const reader = new FileReader()
  reader.onload = (e) => {
    dniFrontPreview.value = e.target.result
  }
  reader.readAsDataURL(file)

  // Verificar automáticamente con OCR si hay DNI introducido
  if (guarantorData.value.dni && validateDni(guarantorData.value.dni).isValid) {
    await verifyDniWithOcr(file, 'front')
  }
}


const removeDniFront = () => {
  dniFrontFile.value = null
  dniFrontPreview.value = ''
  guarantorData.value.dniFrontUrl = ''
}

const saveGuarantor = async () => {
  if (!isFormValid.value) return
  
  isLoading.value = true
  
  try {
    const auth = getAuth()
    const user = auth.currentUser
    
    if (!user) {
      throw new Error('Usuario no autenticado')
    }

    // Enviar email al avalista para que firme él mismo
    await sendGuarantorVerificationEmail()
    
  } catch (error) {
    console.error('Error enviando email al avalista:', error)
    alert('Error al enviar la invitación. Por favor, inténtalo de nuevo.')
  } finally {
    isLoading.value = false
  }
}

const sendGuarantorVerificationEmail = async () => {
  try {
    const auth = getAuth()
    const user = auth.currentUser
    
    if (!user) {
      throw new Error('Usuario no autenticado')
    }

    // Subir imágenes del DNI si existen
    let dniFrontUrl = guarantorData.value.dniFrontUrl

    if (dniFrontFile.value) {
      const storage = getStorage()
      const frontRef = storageRef(storage, `guarantor_dni/${user.uid}/front_${Date.now()}`)
      await uploadBytes(frontRef, dniFrontFile.value)
      dniFrontUrl = await getDownloadURL(frontRef)
    }

    // Eliminado: carga de dorso

    // Generar token de verificación
    const verificationToken = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

    // Mapear la relación al formato esperado por el backend
    const relationshipTypeMap = {
      'Padre/Madre': 'parent',
      'Hermano/a': 'sibling', 
      'Cónyuge': 'spouse',
      'Amigo/a': 'friend',
      'Otro': 'other'
    }

    // Verificar que al menos una imagen del DNI esté verificada
    const frontVerified = ocrVerificationStatus.value.front.status === 'verified'
    if (!frontVerified) {
      throw new Error('Por favor, verifica la imagen frontal del DNI antes de continuar')
    }

    // Guardar datos del avalista en Firebase
    const guarantorInfo = {
      ...guarantorData.value,
      relationshipType: relationshipTypeMap[guarantorData.value.relationshipType] || 'other',
      dniFrontUrl,
      
      status: 'pending_verification',
      verificationToken,
      createdAt: new Date(),
      // Información de verificación OCR
      dniOcrVerified: frontVerified,
      dniOcrVerificationDate: new Date(),
      ocrVerificationDetails: {
        front: frontVerified ? {
          verified: true,
          confidence: ocrVerificationStatus.value.front.confidence
        } : null,
        back: null
      }
    }

    const userRef = doc(db, 'users', user.uid)
    await updateDoc(userRef, {
      hasGuarantor: true,
      guarantorInfo
    })

    // Llamar al backend para enviar email
    const response = await fetch(`https://notarial.online/api/email/send-guarantor-verification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        guarantorEmail: guarantorData.value.email,
        guarantorName: guarantorData.value.fullName,
        applicantName: user.displayName || user.email,
        verificationToken,
        userId: user.uid
      })
    })

    if (!response.ok) {
      throw new Error('Error enviando email de verificación')
    }

    // Emitir evento de éxito
    emit('guarantor-saved', guarantorInfo)
    
    alert('✅ Se ha enviado una invitación al email del avalista para que complete su verificación y firma digital.\n\n📧 El avalista recibirá un enlace seguro para:\n• Revisar la información\n• Firmar digitalmente\n• Confirmar su compromiso como avalista\n\n🔄 El estado se actualizará automáticamente cuando el avalista complete el proceso.')
    
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

// Lifecycle
onMounted(() => {
  if (props.existingGuarantor && Object.keys(props.existingGuarantor).length > 0) {
    // Mapear datos existentes del avalista
    const relationshipDisplayMap = {
      'parent': 'Padre/Madre',
      'sibling': 'Hermano/a',
      'spouse': 'Cónyuge', 
      'friend': 'Amigo/a',
      'other': 'Otro'
    }
    
    guarantorData.value = { 
      ...props.existingGuarantor,
      relationshipType: relationshipDisplayMap[props.existingGuarantor.relationshipType] || 'Otro'
    }
    
    if (props.existingGuarantor.dniFrontUrl) {
      dniFrontPreview.value = props.existingGuarantor.dniFrontUrl
    }
    // Eliminado: pre-carga de dorso
  }
})
</script>

<style scoped>
/* Estilos específicos para el canvas */
canvas {
  touch-action: none;
}

/* Animaciones suaves */
.transition-all {
  transition: all 0.2s ease-in-out;
}

/* Mejoras visuales para móvil */
@media (max-width: 640px) {
  .max-w-2xl {
    max-width: 95vw;
  }
  
  .grid-cols-1.md\:grid-cols-2 {
    grid-template-columns: 1fr;
  }
}
</style> 